export default {
    language: "日本語",
    StripeSuccess: {
        loading: "お支払いを処理中...",
        successMessage: "サブスクリプションが正常に有効化されました！",
        processingError: "支払い処理に失敗しました。お問い合わせください",
    },
    Terms: {
        "tabs": {
            "terms": "利用規約",
            "privacy": "プライバシーポリシー",
            "cookies": "Cookieポリシー"
        },
        "lastUpdated": "最終更新日：2025年5月20日",
        "terms": {
            "sections": [
                {
                    "title": "1. はじめに",
                    "description": "ClixMagicAIへようこそ。当サービスを利用することにより、これらの利用規約に同意したことになります。注意深くお読みください。"
                },
                {
                    "title": "2. サービスの説明",
                    "description": "ClixMagicAIは、画像、動画から透かしを除去するためのAI駆動ツールを提供しています。当サービスは以下の正当な用途を対象としています：",
                    "items": [
                        "自分のコンテンツからの透かしの除去",
                        "適切な変更権利を持つコンテンツからの透かしの除去",
                        "教育および研究目的"
                    ]
                },
                {
                    "title": "3. ユーザーの責任",
                    "description": "ClixMagicAIを使用することにより、以下に同意します：",
                    "items": [
                        "自分が所有しているか、適切な変更権利を持つコンテンツのみをアップロードすること",
                        "当サービスを違法な目的や法律違反のために使用しないこと",
                        "当社のセキュリティ対策や使用制限を回避しようとしないこと",
                        "当サービスを他者の知的財産権を侵害するために使用しないこと"
                    ]
                },
                {
                    "title": "4. アカウント条件",
                    "description": "当サービスの一部機能を使用するには、アカウントの作成が必要な場合があります。ログインするには、GoogleまたはGitHubアカウントを使用することができます。あなたは以下について責任を負います：",
                    "items": [
                        "アカウントのセキュリティ維持",
                        "アカウントで発生するすべてのアクティビティ",
                        "正確なアカウント情報の提供（アバター、メールアドレス、ユーザー名、ユーザーIDを含むがこれらに限定されない）"
                    ]
                },
                {
                    "title": "5. 無料および有料サービス",
                    "description": "ClixMagicAIは、透かし除去機能へのアクセスのために無料基本割当量と柔軟なポイント購入オプションを提供しています：",
                    "items": [
                        "基本割当量：各ユーザーは毎日自動的に10つの無料ポイントを受け取り、コンテンツ処理に使用できます",
                        "ポイント消費ルール：画像透かし除去は1回の操作で1ポイント、動画透かし除去は1回の操作で3ポイントを消費します",
                        "ポイント購入：より多くの使用のためにポイントパッケージを購入することができ、購入したすべてのポイントは期限制限なしで永久に有効です",
                        "返金ポリシー：デジタルサービスの即時性と仮想性の性質上、ポイントは正常に購入された後は返金できません"
                    ]
                },
                {
                    "title": "6. 知的財産権",
                    "description": "当社が作成したすべてのソフトウェア、デザイン、コンテンツを含むClixMagicAIサービスは当社の知的財産です。許可なく当サービスをコピー、修正、または派生作品を作成することはできません。"
                },
                {
                    "title": "7. 責任の制限",
                    "description": "ClixMagicAIは「現状のまま」サービスを提供し、いかなる種類の保証もしません。当サービスの使用によって生じるいかなる損害についても責任を負いません。"
                },
                {
                    "title": "8. 規約の変更",
                    "description": "当社はいつでもこれらの規約を変更することがあります。規約変更後もClixMagicAIの使用を継続することにより、変更された規約に同意したことになります。"
                },
                {
                    "title": "9. 終了",
                    "description": "あなたの行動がこれらの規約に違反している、または他のユーザー、当社自身、または第三者に有害であると判断した場合、予告なしに当サービスへのアクセスを即座に終了または停止する権利を留保します。"
                },
                {
                    "title": "10. 適用法",
                    "description": "これらの規約は、法の抵触に関する規定に関わらず、当社の登録地の適用法に準拠するものとします。"
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. はじめに",
                    "description": "ClixMagicAIでは、お客様のプライバシーを尊重し、個人データの保護に努めています。このプライバシーポリシーは、当ウェブサイトおよびサービスをご利用いただく際に、お客様の情報をどのように収集、使用、保護するかを説明しています。当ウェブサイトにアクセスするか、サービスを利用することにより、このポリシーに記載されているデータ処理方法に同意したことになります。当社は適用されるデータ保護規制を遵守しています。"
                },
                {
                    "title": "2. 収集する情報",
                    "description": "当社は以下の種類の情報を収集することがあります：",
                    "items": [
                        { "bold": "アカウント情報", "text": "GoogleまたはGitHubを通じてログインする際に提供されるユーザーアバター、メールアドレス、ユーザー名、ユーザーID" },
                        { "bold": "利用データ", "text": "アクセスする機能や利用時間を含む、サービスの利用方法に関する情報" },
                        { "bold": "アップロードされたコンテンツ", "text": "処理のためにアップロードされた画像、動画ファイル" },
                        { "bold": "支払い情報", "text": "サブスクリプション購入時の支払い情報（Creem/Stripe/PayPalなどの第三者支払いゲートウェイによって安全に処理され、当社は支払い状態の記録のみを保持します）" },
                        { "bold": "技術データ", "text": "IPアドレス、ブラウザタイプ、デバイス情報" }
                    ]
                },
                {
                    "title": "3. 情報の使用方法",
                    "description": "当社はお客様の情報を以下の目的で使用します：",
                    "items": [
                        { "text": "サービスの提供、維持、改善" },
                        { "text": "取引の処理と完了" },
                        { "text": "技術的な通知とサポートメッセージの送信" },
                        { "text": "お客様のコメントや質問への対応" },
                        { "text": "ユーザー体験を向上させるための利用パターンの分析、およびサービスの目的達成に必要な範囲でのみ個人データの処理" },
                        { "text": "個人データの保存期間が必要な時間を超えないことの保証" },
                        { "text": "詐欺や違法行為の防止" }
                    ]
                },
                {
                    "title": "4. データセキュリティ",
                    "description": "当社はお客様の個人情報を保護するために業界標準のセキュリティ対策を実施しています：",
                    "items": [
                        { "text": "転送および保存中のファイルに対するAES-256暗号化" },
                        { "text": "ゼロ知識アーキテクチャを使用した機密データの処理" },
                        { "text": "毎日のセキュリティログ監査と脆弱性スキャン" },
                        { "text": "従業員のアクセスは最小権限の原則に従います" }
                    ]
                },
                {
                    "title": "5. データ共有",
                    "description": "当社はお客様の個人情報を販売しません。以下と情報を共有することがあります：",
                    "items": [
                        { "bold": "サービスプロバイダー", "text": "特定のサービスを提供するために必要なデータ処理に限定されます（CloundFlareクラウドストレージ、Creem/Stripe/PayPalなどの第三者支払いゲートウェイなど）。これらはデータ処理契約に署名する必要があります" },
                        { "bold": "法的要件", "text": "有効な召喚状、裁判所命令、または当社に適用されるその他の法的手続きを受け取った場合" }
                    ]
                },
                {
                    "title": "6. お客様の権利",
                    "description": "お客様の地域で適用される法律に基づき、以下の権利を持つ場合があります：",
                    "items": [
                        { "text": "個人データのコピーへのアクセス" },
                        { "text": "不正確または不完全な情報の訂正" },
                        { "text": "データ削除の権利（「忘れられる権利」）、ただし当社が保持する法的理由がある場合を除く" },
                        { "text": "特定の種類のデータ処理に対する異議申し立てまたは制限" },
                        { "text": "データポータビリティの権利、データの転送を要求できます" }
                    ]
                },
                {
                    "title": "7. 子どものプライバシー",
                    "description": "当社のサービスは16歳未満の未成年者を対象としていません。一般データ保護規則（GDPR）第8条に従い、16歳未満の子どもの同意は親または保護者によって提供される必要があります。16歳未満の未成年者が当社に個人情報を提供したことを知った場合は、直ちにclixmagicai@gmail.comまでご連絡ください。"
                },
                {
                    "title": "8. このポリシーの変更",
                    "description": "当社は定期的にこのプライバシーポリシーを更新することがあります。重要な変更については、このページに新しいポリシーを掲載し、「最終更新日」を更新することでお知らせします。重要な変更については、メールまたはその他の目立つ方法でユーザーに通知します。"
                },
                {
                    "title": "9. お問い合わせ",
                    "description": "このプライバシーポリシーに関するご質問がある場合は、clixmagicai@gmail.comまでお問い合わせください。データが不適切に処理されたと思われる場合や懸念がある場合も、いつでもお気軽にお問い合わせください。"
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Cookieとは",
                    "description": "Cookieは、ウェブサイトを訪問した際にコンピュータやモバイルデバイスに配置される小さなテキストファイルです。これにより、ウェブサイトはあなたのデバイスを認識し、以前にサイトを訪問したかどうかを記憶することができます。"
                },
                {
                    "title": "2. Cookieの使用方法",
                    "description": "ClixMagicAIは様々な目的でCookieを使用します：",
                    "items": [
                        { "bold": "必須Cookie", "text": "ウェブサイトの基本機能（セッション管理やセキュリティ機能など）に必要です" },
                        { "bold": "設定Cookie", "text": "GoogleやGitHubを通じてログインした後、アバター、ユーザー名などを記憶するなど、あなたの設定や好みを記憶して体験を向上させます" },
                        { "bold": "分析Cookie", "text": "匿名情報を収集することで、訪問者がウェブサイトとどのように対話しているかを理解するのに役立ちます" },
                        { "bold": "マーケティングCookie", "text": "興味に関連する広告を提供するために閲覧習慣を追跡します" }
                    ]
                },
                {
                    "title": "3. 使用するCookieの種類",
                    "subsection": [
                        {
                            "title": "3.1 必須Cookie",
                            "description": "これらのCookieはウェブサイトの正常な機能に不可欠です。セキュリティ、ネットワーク管理、アカウントアクセス（GoogleやGitHubを通じたログインを含む）などの中心的な機能を可能にします。ブラウザでこれらのCookieをブロックするように設定できますが、ウェブサイトの一部が正しく機能しない場合があります。"
                        },
                        {
                            "title": "3.2 パフォーマンスおよび分析Cookie",
                            "description": "これらのCookieは、匿名情報を収集することで、訪問者がウェブサイトとどのように対話しているかを理解するのに役立ちます。当社はこのデータを使用してウェブサイトとサービスを改善します。これらのCookieは、訪問者を特定できる情報を収集しません。"
                        },
                        {
                            "title": "3.3 機能Cookie",
                            "description": "これらのCookieにより、ウェブサイトは、GoogleやGitHubを通じたログイン状態を記憶するなど、パーソナライズされた拡張機能を提供するために、あなたが行った選択（言語設定やログイン状態など）を記憶できます。"
                        },
                        {
                            "title": "3.4 ターゲティングおよび広告Cookie",
                            "description": "これらのCookieは、訪問者に関連する広告を表示し、広告キャンペーンの効果を追跡するために使用されます。当ウェブサイトは主に第三者接続（GoogleおよびGitHub）に依存しているため、このタイプのCookieは主にユーザー体験の向上に使用され、直接的なマーケティングには使用されないことにご注意ください。"
                        }
                    ]
                },
                {
                    "title": "4. Cookieの管理",
                    "description": "Cookieはさまざまな方法で制御および管理できます。ほとんどのウェブブラウザでは、Cookie設定を管理できます。以下のことが可能です：",
                    "items": [
                        { "text": "デバイスからCookieを削除する" },
                        { "text": "一部またはすべてのCookieを拒否できるブラウザ設定を有効にしてCookieをブロックする" },
                        { "text": "Cookieを受け取ったときに警告するようブラウザを設定する" }
                    ]
                },
                {
                    "title": "5. お問い合わせ",
                    "description": "Cookieに関するご質問がある場合は、clixmagicai@gmail.comまでお問い合わせください。当社がCookieをどのように使用しているか、またそれらをどのように管理できるかをより深く理解するお手伝いをさせていただきます。"
                }
            ]
        }
    },
    UserFeedback: {
        title: "ユーザーの声",
        feedback: "世界中のクリエイターやプロフェッショナルからの、当社のAI画像処理技術に関する実際のレビューをご覧ください。",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "林さん",
                profession: "ビデオ編集者 & コンテンツクリエイター",
                rating: 5,
                comment: "素晴らしい！ClixMagicAIは超高速です！透かし入りの動画をアップロードすると、数分で透かしのないバージョンが手に入り、品質の低下は全くありません。透かし除去に必須のツールです！"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "蘇さん",
                profession: "ソーシャルメディアマーケティングの専門家",
                rating: 5,
                comment: "ClixMagicAIは私のInstagramコンテンツライブラリを救いました！複雑な透かしも正確に認識され、エッジ処理は他のソフトウェアよりもはるかに滑らかで、結果も自然な見た目になります。"
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "陳さん",
                profession: "ショートビデオコンテンツプロデューサー",
                rating: 5,
                comment: "ClixMagicAIでの透かし除去は非常に便利です。通勤中にTikTokのコンテンツを処理し、オフィスに着いたらすぐにHD版をダウンロードできます！メディアプロフェッショナルにとって本当に助かります。"
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "黄さん",
                profession: "グラフィックデザイナー & ビジュアルクリエイティブディレクター",
                rating: 5,
                comment: "デザイナーとして非常に満足しています！クライアントから提供されたロゴ入り画像を処理する際、背景テクスチャが自然に復元され、Photoshopの痕跡がなく、後処理の時間を節約できます。"
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "エミリーさん",
                profession: "フリーランスのデジタルコンテンツクリエイター",
                rating: 5,
                comment: "素晴らしい発見です！会員価格は他の透かし除去製品よりもはるかに手頃ですが、透かし除去の効果は実際にはより優れています。特にグラデーション透かしの処理が得意です。"
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "ロバートソンさん",
                profession: "企業研修コース開発者",
                rating: 5,
                comment: "ClixMagicAIはインストールが不要で非常に便利です！会社のコンピューターではソフトウェアのインストールが制限されていますが、ブラウザだけでコース素材を処理できるようになり、どこでもいつでも使えます。"
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "周さん",
                profession: "主婦 & コミュニティメディア編集者",
                rating: 5,
                comment: "インターフェースがとても簡単で、私の祖母でも使えるほどです！Photoshopのようなプロフェッショナルソフトウェアを学ぶ時間がないなら、ClixMagicAIを試してみてください。私のような技術初心者に最適です！"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "ジョンソンさん",
                profession: "Eコマースビジュアルストラテジスト",
                rating: 5,
                comment: "ClixMagicAIは非常に強力で、画像、動画、小物、人物、テキストなどを除去できます。機能が包括的で、皆さんにお勧めします！"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "方さん",
                profession: "写真愛好家 & オンラインコンテンツシェアラー",
                rating: 5,
                comment: "わあ～画質を損なわない透かし除去ツールをついに見つけました！まるで魔法のように素晴らしい～写真編集がもう問題ではありません！強くお勧めします！！！"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "ウィリアムズさん",
                profession: "オンライン教育講師",
                rating: 5,
                comment: "透かし位置メモリ機能は非常に便利です！シリーズコース動画を処理する際に何度も選択する必要がなく、少なくとも30分の作業時間を節約でき、教育準備の効率が大幅に向上しました。"
            }
        ]
    },
    UserDetail: {
        userInfo: {
            emailLabel: "メール",
            createdAt: "作成日時",
            noRecord: "記録なし",
            loginTime: "ログイン時間",
        },
        orders: {
            title: "注文履歴",
            loading: "読み込み中...",
            refresh: "更新",
            orderAmount: "金額",
            points: "ポイント",
            createdAt: "作成日時",
            orderType: "タイプ",
            status: "ステータス",
            noOrders: "注文がありません",
            goToSubscription: "ポイントを購入",
            freeCredit: "無料クレジット",
            paidCredit: "有料クレジット",
            queryOrderFailed: "注文の照会に失敗しました",
            statusPaid: "支払済み",
            statusPending: "保留中",
            statusCancelled: "キャンセル済み",
            statusDeactivated: "無効",
            checkoutUrlNotAvailable: "決済URLの取得に失敗しました",
            verifyingPayment: "支払い状況を確認中...",
            paymentSuccess: "支払い成功",
            paymentPending: "注文は支払い待ちです。支払いを完了してください",
            paymentFailed: "支払いに失敗したかキャンセルされました",
            paymentStatus: "支払い状況",
            paymentStatusDescription: "支払いを完了しましたか？",
            cancelPayment: "支払いをキャンセル",
            completedPayment: "支払い完了",
            warning: "警告",
            confirmCancelOrder: "この注文をキャンセルしてもよろしいですか？このアクションは元に戻せません。",
            cancel: "キャンセル",
            confirm: "確認",
            cancellingOrder: "注文をキャンセル中...",
            orderCancelledSuccess: "注文がキャンセルされました",
            cancelOrderFailed: "注文のキャンセルに失敗しました",
            checkOrderStatusFailed: "注文状況の確認に失敗しました",
            promptClick: "「保留中」ステータスをクリックして支払いを続行",
        }
    },
    Order: {
        purchasePoints: "ポイント購入",
        subtitle: "高品質なウォーターマーク除去サービスを利用するために適切なポイントパッケージを選択してください",
        loginReminderDesc: "ポイントを選択して購入するにはログインしてください",
        freeTag: "無料",
        freePlan: "無料プラン",
        autoActivated: "ログイン後自動的に有効化",
        points: "ポイント",
        autoIncluded: "無料ギフト",
        discount: "割引",
        purchase: "今すぐ購入",
        paymentStatusDescription: "支払いを完了しましたか？",
        paymentNotCompleted: "支払いが完了していません",
        queryOrderFailed: "注文状況の確認に失敗しました",
        cancelPayment: "支払いをキャンセル",
        completedPayment: "支払い完了",
        warning: "警告",
        confirmCancelOrder: "この注文をキャンセルしてもよろしいですか？この操作は元に戻せません。",
        cancel: "キャンセル",
        confirm: "確認",
        selectProductFirst: "まずパッケージを選択してください",
        creatingOrder: "注文を作成中...",
        orderCreated: "注文が正常に作成されました",
        createOrderFailed: "注文の作成に失敗しました",
        checkoutUrlNotAvailable: "支払いリンクの取得に失敗しました",
        cancellingOrder: "注文をキャンセル中...",
        orderCancelledSuccess: "注文がキャンセルされました",
        cancelOrderFailed: "注文のキャンセルに失敗しました",
        verifyingPayment: "支払い状況を確認中...",
        paymentSuccess: "支払い成功",
        paymentPending: "注文の支払い待ち、支払いを完了してください",
        paymentFailed: "支払いに失敗したかキャンセルされました",
        checkOrderStatusFailed: "注文状況の確認に失敗しました",
        quickStart: "クイックスタート",
        shortTerm: "短期利用",
        recommended: "おすすめ",
        bestValue: "ベストバリュー",
    },
    Login: {
        title: "ログイン",
        subtitle: "ソーシャルアカウントでクイックログイン",
        memberTip: "より多くの機能を利用するにはログインしてください",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "GitHubアカウントでログイン"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Googleアカウントでログイン"
            }
        ],
        error: {
            serverError: "サーバーエラー、後ほど再試行してください",
            networkError: "ネットワークエラー、接続を確認してください"
        }
    },
    OAuthCallback: {
        loading: "ログインリクエストを処理中",
        pleaseWait: "お待ちください、ログイン情報を確認中...",
        error: "ログイン失敗",
        backToHome: "ホームに戻る",
        success: "ログイン成功",
        redirecting: "ホームページにリダイレクト中..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "価格",
            faq: "よくある質問",
        },
        login: "ログイン",
        userMenu: {
            account: "アカウント",
            logout: "ログアウト",
            credit: "ポイント",
            freeCredit: "無料",
            paidCredit: "購入済み",
            nextUpdate: "次回ポイント更新",
            language: "言語",
            theme: "テーマ",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "ClixMagicAIの特徴",
        advs: [
            {
                title: "AI自動認識エンジン：邪魔な要素を自動検出",
                desc: "ディープラーニングアルゴリズムに基づき、画像/動画内のウォーターマーク、テキスト、顔、複雑な背景要素を手動マーキングなしで自動認識します。InstagramやTikTokなどのプラットフォームフォーマットをサポートし、プライベートデータを厳格に保護します。",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "ウォーターマーク除去"
            },
            {
                title: "画像クリーニングマスター：ロゴ/日付スタンプを素早く除去、品質保持",
                desc: "ブランドウォーターマーク、撮影日、ステッカーなどの邪魔な要素を正確に削除します。AIが自動的に背景テクスチャを復元し、処理後の画像はオリジナルのように自然で、ソーシャルメディア投稿に最適です。",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "ウォーターマーク除去"
            },
            {
                title: "動的ウォーターマーク除去：スクロールする字幕/プラットフォームロゴを消去",
                desc: "YouTubeのエンドカード、TikTokの動的ウォーターマーク、スクロールテキストをワンクリックで除去します。AIスマートトラッキングが各フレームを処理し、滑らかな4K高品質動画を出力し、MP4/MOVなど一般的なフォーマットをサポートします。",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "ウォーターマーク除去"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "画像、動画からウォーターマークを素早く簡単に除去するプロフェッショナルなAI搭載ツールで、自然な結果を提供します。",
        fileTypes: {
            image: '画像ウォーターマーク除去',
            pdf: 'PDFウォーターマーク除去',
            video: '動画ウォーターマーク除去'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "毎日無料トライアル", icon: "fa-gift" },
            { id: "imageTag", text: "画像ウォーターマーク除去", icon: "fa-image" },
            { id: "videoTag", text: "動画ウォーターマーク除去", icon: "fa-video" },
            { id: "aiPoweredTag", text: "AI駆動", icon: "fa-robot" },
            { id: "noRegTag", text: "ログイン＆使用", icon: "fa-user-check" },
        ],
        videoPromt: "近日公開！",
        videoDesc: "より良い体験を提供する動画ウォーターマーク除去機能を開発中です。"
    },
    Footer: {
        social: {
            title: "お問い合わせ",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "法的条項",
        terms: [
            {
                id: 1,
                title: "プライバシーポリシー",
                link: "/privacy"
            },
            {
                id: 2,
                title: "利用規約",
                link: "/terms"
            },
            {
                id: 3,
                title: "Cookie ポリシー",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI 全著作権所有。"
    },
    Task: {
        image: {
            imageSupportText: 'jpg、jpeg、png、webp、heic、heif形式をサポート、ファイルあたり最大10MB',
            imageFileTooLarge: 'ファイルサイズが制限を超えています（最大10MB）',
            invalidImageType: '対応していない画像形式です。JPG、JPEG、PNG、WEBP、HEIC、HEIFをアップロードしてください',
            imageWillCost: '消費ポイント：1ポイント',
            hiecSupportText: 'HEIC/HEIF形式は送信時に自動的にPNG形式に変換されます',
            hiecSuccess: 'HEIC/HEIF形式の変換に成功しました',
            hiecFailed: 'HEIC/HEIF形式の変換に失敗しました',
            processingImageTip: '画像を処理中です。お待ちください...',
            guide: {
                title: '使用ガイド',
                step1: '画像をアップロード',
                step2: 'ウォーターマークエリアをブラシで塗るか、モデルが自動的にウォーターマークを検出します',
                step3: '送信をクリック'
            }
        },
        common: {
            remaining: '残りポイント',
            nextUpdate: '次回ポイント更新',
            handleError: 'ファイル処理中にエラーが発生しました。別のファイルをお試しください',
            uploadFailed: 'ファイルのアップロードに失敗しました',
            dragText: 'ファイルをここにドラッグするか',
            clickText: 'クリックしてアップロード',
            loginRequired: 'ファイルをアップロードするにはログインしてください',
            noRemainingTasks: 'ポイントがすべて使用されています',
            loginNow: '今すぐログイン',
            upgradeNow: '今すぐポイントを購入',
            taskSubmitSuccess: 'タスクが正常に送信されました',
            taskSubmitError: 'タスクの送信に失敗しました',
            taskRetrySuccess: 'タスクの再試行が正常に送信されました！',
            taskRetryError: 'タスクの再試行の送信に失敗しました！',
            processing: '処理中',
            submit: '送信',
            waiting: '待機中',
            completed: '完了',
            failed: '失敗',
            cancelled: 'キャンセル',
            url_not_found: 'リンクの取得に失敗しました',
            deleted: '削除済み',
            refreshSuccess: 'タスクリストが更新されました',
            refreshFailed: 'タスクリストの更新に失敗しました',
            deleteSuccess: 'タスクが正常に削除されました',
            deleteFailed: 'タスクの削除に失敗しました',
            waitingForCompletion: '現在のタスクが完了するまでお待ちください',
            loadOriginalImageFailed: '元の画像の読み込みに失敗しました。再試行してください',
            downloadFailed: 'ダウンロードに失敗しました',
            startingDownload: 'ダウンロードを開始中...',
            noTasks: 'タスクがありません',
            refresh: '更新',
            sort: '並べ替え',
            noFilterTasks: '{filter}タスクはありません',
            compare: '比較を表示',
            originalImage: '元の画像',
            processedImage: '処理後の画像',
            dragToCompare: '👈 左右にドラッグして比較 👉',
            cancel: "キャンセル",
            delete: "削除",
            retry: "再試行",
            download: "ダウンロード",
            createAt: "作成日時",
            expiredAt: "有効期限",
        },
        video: {
            videoSupportText: 'mp4、mov、avi、mkv形式をサポート、ファイルあたり最大100MB',
            videoFileTooLarge: 'ファイルサイズが制限を超えています（最大100MB）',
            invalidVideoType: '対応していない動画形式です。MP4、MOV、AVI、MKVをアップロードしてください',
            videoWillCost: '消費ポイント：3ポイント',
            processingVideoTip: '動画を処理中です。お待ちください...',
            guide: {
                step1: '動画をアップロード',
                step2: 'ウォーターマークタイプを選択してウォーターマークエリアを指定',
                step3: '送信をクリック'
            },
            annotationTools: 'ウォーターマーク注釈ツール',
            selectType: 'ウォーターマークタイプを選択',
            deleteAnnotation: '注釈を削除',
            clearAllAnnotations: 'すべての注釈をクリア',
            annotationHelp: '注釈ヘルプ',
            dragTip: 'ドラッグしてウォーターマークエリアを描画',
            resizeTip: 'ウォーターマークに合わせてサイズ調整',
            moveTip: '作成した注釈は移動できます',
            processing: '処理中',
            submit: '送信',
            taskSubmitSuccess: 'タスクが正常に送信されました',
            taskSubmitError: 'タスクの送信に失敗しました',
            retryTaskTip: 'タスクの再試行が正常に送信されました',
            retryFailed: 'タスクの再試行に失敗しました',
            uploadFailed: 'アップロードに失敗しました',
            staticWatermarkDesc: '固定位置の静的ウォーターマークに適しています',
            normalWatermarkDesc: '通常の固定ウォーターマークに適しています',
            dynamicWatermarkDesc: '変化する動的ウォーターマークに適しています',
            moveWatermarkDesc: '移動が必要なウォーターマークに適しています'
        },
    },
    Router: {
        home: "ホーム",
        terms: "利用規約",
        privacy: "プライバシーポリシー",
        cookie: "Cookieポリシー",
        user: "ユーザーセンター",
    },
    FAQ: {
        title: "ClixMagicAI 使用ガイドとよくある質問",
        prompt: "問題や質問がありますか？いつでもお問い合わせください：clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "ClixMagicAIとは何か、どのように機能しますか？",
                answer: "ClixMagicAIは、先進的なAI駆動の透かし除去ツールです。画像や動画の透かしを自動認識し、手動で透かし位置をマークする機能も提供しています。画像については、複数のフォーマット変換をサポートし、高品質な出力を保証します。動画については、静的、動的、さらには形状が変化する透かしも処理できます。"
            },
            {
                id : 2,
                question: "ClixMagicAIは無料で使えますか？",
                answer: "はい、毎日10ポイントの基本無料サービスを提供しています！これを使って画像（1回の操作につき1ポイント消費）または動画（1回の操作につき3ポイント消費）を処理できます。現在、追加ポイントの購入はサポートされておらず、毎日付与される10ポイントのみ利用可能です。"
            },
            {
                id : 3,
                question: "追加ポイントを購入できますか？",
                answer: "現段階では追加ポイントの購入はサポートされていません。各ユーザーは1日10ポイントのみ獲得でき、翌日に自動的にリフレッシュされます。"
            },
            {
                id : 4,
                question: "どのようなファイル形式をサポートしていますか？",
                answer: "画像については、PNG、JPEG、JPG、WEBP、HEIC、HEIF形式をサポートしており、HEICとHEIFは自動的にPNGに変換されます。動画については、MP4、MOVを含む複数の形式をサポートしています。"
            },
            {
                id : 5,
                question: "プライバシーはどのように保護されますか？",
                answer: "ClixMagicAIでは、ユーザーのプライバシーを非常に重視しています。アップロードされたすべてのファイルは暗号化され、処理完了後24時間以内に自動的に削除されます。ユーザーファイルや関連情報は一切保存しません。"
            },
            {
                id : 6,
                question: "ClixMagicAIにはどのようにログインできますか？",
                answer: "GitHubまたはGoogleアカウントを通じて迅速にログインでき、アカウントのセキュリティを確保しながら登録プロセスを簡素化します。"
            },
            {
                id : 7,
                question: "処理速度はどれくらい速いですか？",
                answer: "高性能サーバーと最適化されたAIアルゴリズムにより、ほとんどの画像透かし除去タスクは10秒以内に完了し、動画透かし除去は最速で1分しかかかりません。実際の時間はファイルサイズと複雑さによって異なる場合があります。"
            },
            {
                id : 8,
                question: "処理後の効果はどうですか？",
                answer: "当社のAIモデルは広範なトレーニングを受けており、画像や動画の透かしを元のコンテンツの品質を維持しながらインテリジェントに除去できます。自動認識された透かしでも手動でマークされた透かしでも、効果的に除去され、最終結果が自然で跡が残らないことを保証します。"
            },
            {
                id : 9,
                question: "各タスクの有効期間はどれくらいですか？",
                answer: "タスクが完了すると、処理されたファイルはユーザーがダウンロードできるようClixMagicAIに24時間保存されます。期限が切れると、ファイルはプライバシー保護のため自動的にサーバーから削除されます。"
            },
            {
                id : 10,
                question: "最大ファイルサイズ制限はどれくらいですか？",
                answer: "受け付ける最大画像ファイルサイズは10MB、動画ファイルは最大100MBです。この制限を超えるファイルは、アップロード前に圧縮または切り取りが必要な場合があります。"
            }
        ]
    },
}